export default __webpack_public_path__ + "static/media/drawn-map-poi-icon.2349bf2d.svg";